module.exports = __webpack_public_path__ + "DINNextRoundedLTPro-Bold.eot?05fe965d0e64339b39dff8c359b529a0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextRoundedLTPro-Bold.eot
// module id = 318
// module chunks = 0